import React from 'react'

function Feature() {
    return (
        <div className="container-xxl py-5">
            <div className="container py-5 px-lg-5">
                <div className="row g-4">
                    <div className="col-lg-4 wow fadeInUp" data-wow-delay="0.1s">
                        <div className="feature-item bg-light rounded text-center p-4">
                            <div className="service-icon flex-shrink-0">
                                <i className="fab text-primary fa-android fa-3x mb-4" />
                            </div>
                            <h5 className="mb-3">App Developement</h5>
                            <div className="vertically-aligned">
                                <p className="m-0">Offering custom, user-centric app development with cross-platform compatibility, scalable architecture, and ongoing support to ensure optimal performance and security of your application.</p>
                            </div> </div>
                    </div>

                    <div className="col-lg-4 wow fadeInUp" data-wow-delay="0.5s">
                        <div className="feature-item bg-light rounded text-center p-4">
                            <i className="fa fa-3x fa-laptop-code text-primary mb-4" />
                            <h5 className="mb-3">Web Design &amp; Development</h5>
                            <p className="m-0">At DGM, we create innovative, responsive, and user-friendly websites tailored to your needs, leveraging the latest technologies to build robust, scalable, and high-performing online solutions.</p>
                        </div>
                    </div>

                    <div className="col-lg-4 wow fadeInUp" data-wow-delay="0.3s">
                        <div className="feature-item bg-light rounded text-center p-4">
                            <i className="fa fa-3x  fa-users text-primary mb-4" />
                            <h5 className="mb-3">Talent On-Demand</h5>
                            <p className="m-0">Access top-tier professionals on a flexible basis to meet your business needs and drive success. Our comprehensive staffing solutions ensure you have the right talent at the right time to achieve your goals.</p>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default Feature